import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import Login from "./LoginPage";
import ForgotPassword from "./ForgotPasswordPage";
import Changepassword from "./ChangePasswordPage";
import Logo from "../../assets/images/final-logo.png";
export function AuthPage() {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "white" }}>
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          width: "50%",
          alignItems: "center",
          justifyContent: "center",
          p: 5,
        }}
      >
        <img alt="logo" src={Logo} style={{ maxWidth: 500, width: "100%" }} />
      </Box>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          p: 4,
          overflow: "hidden",
        }}
      >
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="changepassword" element={<Changepassword />} />
          <Route path="*" element={<Navigate to="/auth/login" replace />} />
        </Routes>
      </Box>
    </Box>
  );
}
